import {createContext, useContext, useEffect, useState} from "react";
import {SettingApi} from "../utils/SettingApi";

const DataContext = createContext(null);
const DataProvider = ({children}) => {
    const [state, setState] = useState({news: {count:0,data:[]}, service: [], benefit: [], customer: [], person: []});

    const fetchData = async () => {
        await SettingApi.getSetting2((result) => {
            setState(result.data);
        }, (error) => {

        });
    }
    useEffect(() => {
        (async () => {
            await fetchData();
        })();
    }, []);

    return (
        <DataContext.Provider value={{state}}>
            {children}
        </DataContext.Provider>
    )
}
const useDataState = () => {
    const state = useContext(DataContext).state;
    return {
        state
    }
}
export {DataProvider, useDataState, DataContext};
